import type { TransactionsResponseData } from '@mobi/api-types/account/transactions'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import type { TicketResponseData } from '@core/Areas/Account/Pages/Activity/types'

export function isKambiHistoryCoupon(
  page: TicketResponseData | TransactionsResponseData | KambiHistoryCoupon
): page is KambiHistoryCoupon {
  return 'couponRef' in page
}
